import React from "react";
import { useNavigate } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { money, titleCase } from "@/lib/format";
import { Watch as WatchIcon } from "lucide-react";

export const PUBLIC_STATUS_STYLE = {
  available: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  reserved: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  sold: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30",
  incoming: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  authentication_pending: "bg-purple-500/15 text-purple-300 border-purple-500/30",
};

export const PUBLIC_STATUS_LABEL = {
  available: "Available",
  reserved: "Reserved",
  sold: "Sold",
  incoming: "Incoming",
  authentication_pending: "In Authentication",
};

export default function WatchCard({ watch }) {
  const navigate = useNavigate();
  const photo = watch.public_photos?.[0]?.url;
  return (
    <button
      onClick={() => navigate(`/watches/${watch.id}`)}
      data-testid={`watch-card-${watch.id}`}
      className="group text-left bg-[var(--panel)] border border-[var(--border-lch)] rounded-lg overflow-hidden hover:border-[#c9a86a]/50 hover:-translate-y-1 hover:shadow-[0_18px_44px_-22px_rgba(0,0,0,0.85)] transition-[transform,border-color,box-shadow] duration-300"
    >
      <div className="relative aspect-square bg-[var(--panel-2)] overflow-hidden">
        {photo ? (
          <img src={fileUrl(photo)} alt={`${watch.brand} ${watch.model}`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[var(--muted)]"><WatchIcon size={40} /></div>
        )}
        <div className="absolute top-3 left-3">
          <span className={`text-[10px] px-2 py-1 rounded-full border tracking-wide ${PUBLIC_STATUS_STYLE[watch.status] || ""}`}>
            {PUBLIC_STATUS_LABEL[watch.status] || titleCase(watch.status)}
          </span>
        </div>
        {watch.top_pick && (
          <div className="absolute top-3 right-3 text-[10px] px-2 py-1 rounded-full bg-[#c9a86a] text-[var(--on-gold)] tracking-wide font-semibold">TOP PICK</div>
        )}
      </div>
      <div className="p-4">
        <div className="text-[11px] text-[var(--muted)] tracking-wide uppercase">{watch.brand}</div>
        <div className="text-[var(--text)] font-medium mt-0.5 truncate">{watch.model}</div>
        <div className="text-xs text-[var(--muted)] mt-1">{watch.reference_number || "—"}{watch.year ? ` · ${watch.year}` : ""}</div>
        <div className="mt-3 text-[#c9a86a] font-medium">
          {watch.price_on_request ? <span className="italic text-sm text-[var(--text-2)]">Price on Request</span> : (money(watch.price) || "—")}
        </div>
      </div>
    </button>
  );
}
